import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { WORK_SHIFT_PATHS } from '../../../work-shift';
import { ActivatedRoute } from '@angular/router';
import { WorkShiftService } from '../../../work-shift.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-work-shift-sectors',
  templateUrl: './work-shift-sectors.component.html',
  styleUrls: ['./work-shift-sectors.component.scss'],
  standalone: false,
})
export class WorkShiftSectorsComponent implements OnInit {
  tabsNavLinks = [
    {
      title: 'Статусы сотрудников',
      link: WORK_SHIFT_PATHS.work_shift_worker_statuses,
    },
    {
      title: 'Формирование бригад',
      link: WORK_SHIFT_PATHS.work_shift_brigades,
    },
    {
      title: 'Распределение заявок',
      link: WORK_SHIFT_PATHS.work_shift_tickets,
    },
    {
      title: 'Распределение заявок (new)',
      link: WORK_SHIFT_PATHS.work_shift_tickets_new,
    },
    {
      title: 'Мониторинг смены',
      link: WORK_SHIFT_PATHS.work_shift_monitoring,
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private workShiftService: WorkShiftService
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.workShiftService.setSectorData(params);
    });
  }
}
